var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "labelStyle" },
        [
          _vm.cadastrante.pessoa.cadastranteInterno
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Processo feito por funcionário do ITERMA?:",
                      content: _vm.verificaCadastranteInterno()
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "labelStyle" },
        [
          _c("el-col", { attrs: { span: 12 } }, [
            _vm.cadastrante.pessoa.pessoaFisica &&
            _vm.cadastrante.pessoa.pessoaFisica.cpf
              ? _c(
                  "div",
                  { key: "pessoaFisica" },
                  [
                    _vm.cadastrante.pessoa.pessoaFisica.cpf
                      ? _c("app-display", {
                          class:
                            _vm.compararCadastrante &&
                            _vm.compararCadastrante.mudouPessoa &&
                            _vm.compararCadastrante.mudouPessoa.mudouCPF
                              ? "text"
                              : "",
                          attrs: {
                            label: "CPF:",
                            content: _vm.cadastrante.pessoa.pessoaFisica.cpf
                          }
                        })
                      : _vm._e(),
                    _vm.cadastrante.pessoa.pessoaFisica.nome
                      ? _c("app-display", {
                          class:
                            _vm.compararCadastrante &&
                            _vm.compararCadastrante.mudouPessoa &&
                            _vm.compararCadastrante.mudouPessoa.mudouNome
                              ? "text"
                              : "",
                          attrs: {
                            label: "Nome:",
                            content: _vm.cadastrante.pessoa.pessoaFisica.nome
                          }
                        })
                      : _vm._e(),
                    _vm.cadastrante.pessoa.pessoaFisica.rg
                      ? _c("app-display", {
                          class:
                            _vm.compararCadastrante &&
                            _vm.compararCadastrante.mudouPessoa &&
                            _vm.compararCadastrante.mudouPessoa.mudouRG
                              ? "text"
                              : "",
                          attrs: {
                            label: "RG:",
                            content: _vm.cadastrante.pessoa.pessoaFisica.rg
                          }
                        })
                      : _vm._e(),
                    _vm.cadastrante.pessoa.pessoaFisica
                      .municipioEstadoNaturalidade
                      ? _c("app-display", {
                          class:
                            _vm.compararCadastrante &&
                            _vm.compararCadastrante.mudouPessoa &&
                            _vm.compararCadastrante.mudouPessoa
                              .mudouNaturalidade
                              ? "text"
                              : "",
                          attrs: {
                            label: "Naturalidade:",
                            content:
                              _vm.cadastrante.pessoa.pessoaFisica
                                .municipioEstadoNaturalidade
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm.cadastrante.pessoa.pessoaJuridica &&
            _vm.cadastrante.pessoa.pessoaJuridica.cnpj
              ? _c(
                  "div",
                  [
                    _vm.cadastrante.pessoa.pessoaJuridica.orgao
                      ? _c("app-display", {
                          class:
                            _vm.compararCadastrante &&
                            _vm.compararCadastrante.mudouPessoa &&
                            _vm.compararCadastrante.mudouPessoa.mudouOrgao
                              ? "text"
                              : "",
                          attrs: {
                            label: "Pessoa Jurídica:",
                            content: _vm.cadastrante.pessoa.pessoaJuridica.orgao
                          }
                        })
                      : _vm._e(),
                    _vm.cadastrante.pessoa.pessoaJuridica.cnpj
                      ? _c("app-display", {
                          class:
                            _vm.compararCadastrante &&
                            _vm.compararCadastrante.mudouPessoa &&
                            _vm.compararCadastrante.mudouPessoa.mudouCNPJ
                              ? "text"
                              : "",
                          attrs: {
                            label: "CNPJ:",
                            content: _vm.cadastrante.pessoa.pessoaJuridica.cnpj
                          }
                        })
                      : _vm._e(),
                    _vm.cadastrante.pessoa.pessoaJuridica.razaoSocial
                      ? _c("app-display", {
                          class:
                            _vm.compararCadastrante &&
                            _vm.compararCadastrante.mudouPessoa &&
                            _vm.compararCadastrante.mudouPessoa.mudouRazaoSocial
                              ? "text"
                              : "",
                          attrs: {
                            label: "Razão Social:",
                            content:
                              _vm.cadastrante.pessoa.pessoaJuridica.razaoSocial
                          }
                        })
                      : _vm._e(),
                    _vm.cadastrante.pessoa.pessoaJuridica.cpf
                      ? _c("app-display", {
                          class:
                            _vm.compararCadastrante &&
                            _vm.compararCadastrante.mudouRepresentanteLegal &&
                            _vm.compararCadastrante.mudouRepresentanteLegal
                              .mudouPessoa.mudouCPF
                              ? "text"
                              : "",
                          attrs: {
                            label: "CPF do representante legal:",
                            content: _vm.cadastrante.pessoa.pessoaJuridica.cpf
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e()
          ]),
          _vm.cadastrante.pessoa.pessoaJuridica &&
          _vm.cadastrante.pessoa.pessoaJuridica.cnpj
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _vm.cadastrante.pessoa.pessoaJuridica.nome
                    ? _c("app-display", {
                        class:
                          _vm.compararCadastrante &&
                          _vm.compararCadastrante.mudouRepresentanteLegal &&
                          _vm.compararCadastrante.mudouRepresentanteLegal
                            .mudouPessoa.mudouNome
                            ? "text"
                            : "",
                        attrs: {
                          label: "Nome do representante legal:",
                          content: _vm.cadastrante.pessoa.pessoaJuridica.nome
                        }
                      })
                    : _vm._e(),
                  _vm.cadastrante.pessoa.telefones &&
                  _vm.tipoProcesso !== "NAO_ONEROSO"
                    ? _c("app-display-multiple", {
                        class:
                          _vm.compararCadastrante &&
                          _vm.compararCadastrante.mudouPessoa &&
                          _vm.compararCadastrante.mudouPessoa.mudouTelefones
                            ? "text"
                            : "",
                        attrs: {
                          label: "Telefone(s):",
                          content: _vm.formatTelefone(
                            _vm.cadastrante.pessoa.telefones
                          )
                        }
                      })
                    : _vm._e(),
                  (_vm.isBahia
                  ? _vm.cadastrante.pessoa.emails
                  : _vm.cadastrante.pessoa.email)
                    ? _c("app-display", {
                        class:
                          _vm.compararCadastrante &&
                          _vm.compararCadastrante.mudouPessoa &&
                          _vm.compararCadastrante.mudouPessoa.mudouEmail
                            ? "text"
                            : "",
                        attrs: {
                          label: "E-mail:",
                          isArray: _vm.isBahia,
                          content: _vm.isBahia
                            ? _vm.cadastrante.pessoa.emails
                            : _vm.cadastrante.pessoa.email
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.isBahia &&
          _vm.cadastrante.pessoa.pessoaJuridica &&
          _vm.cadastrante.pessoa.pessoaJuridica.cnpj
            ? _c(
                "div",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _vm.isBahia &&
                      _vm.cadastrante.pessoa.pessoaJuridica.responsavel.cpf
                        ? _c("app-display", {
                            class:
                              _vm.compararCadastrante &&
                              _vm.compararCadastrante.mudouPessoa &&
                              _vm.compararCadastrante.mudouPessoa
                                .mudouResponsavelPessoaJuridica &&
                              _vm.compararCadastrante.mudouPessoa
                                .mudouResponsavelPessoaJuridica.mudouCpf
                                ? "text"
                                : "",
                            attrs: {
                              label: "CPF do Responsável pelo Preenchimento:",
                              content:
                                _vm.cadastrante.pessoa.pessoaJuridica
                                  .responsavel.cpf
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _vm.cadastrante.pessoa.pessoaJuridica.responsavel.nome
                        ? _c("app-display", {
                            class:
                              _vm.compararCadastrante &&
                              _vm.compararCadastrante.mudouPessoa &&
                              _vm.compararCadastrante.mudouPessoa
                                .mudouResponsavelPessoaJuridica &&
                              _vm.compararCadastrante.mudouPessoa
                                .mudouResponsavelPessoaJuridica.mudouNome
                                ? "text"
                                : "",
                            attrs: {
                              label: "Nome do Responsável pelo Preenchimento:",
                              content:
                                _vm.cadastrante.pessoa.pessoaJuridica
                                  .responsavel.nome
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _vm.cadastrante.pessoa.pessoaJuridica.responsavel
                        .telefones
                        ? _c("app-display-multiple", {
                            class:
                              _vm.compararCadastrante &&
                              _vm.compararCadastrante.mudouPessoa &&
                              _vm.compararCadastrante.mudouPessoa
                                .mudouResponsavelPessoaJuridica &&
                              _vm.compararCadastrante.mudouPessoa
                                .mudouResponsavelPessoaJuridica.mudouTelefones
                                ? "text"
                                : "",
                            attrs: {
                              label:
                                "Telefone(s) do Responsável pelo Preenchimento:",
                              content: _vm.formatTelefone(
                                _vm.cadastrante.pessoa.pessoaJuridica
                                  .responsavel.telefones
                              )
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _vm.cadastrante.pessoa.pessoaJuridica.responsavel.emails
                        ? _c("app-display", {
                            class:
                              _vm.compararCadastrante &&
                              _vm.compararCadastrante.mudouPessoa &&
                              _vm.compararCadastrante.mudouPessoa
                                .mudouResponsavelPessoaJuridica &&
                              _vm.compararCadastrante.mudouPessoa
                                .mudouResponsavelPessoaJuridica.mudouEmail
                                ? "text"
                                : "",
                            attrs: {
                              label:
                                "E-mail do Responsável pelo Preenchimento:",
                              isArray: true,
                              content:
                                _vm.cadastrante.pessoa.pessoaJuridica
                                  .responsavel.emails
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.cadastrante.pessoa.pessoaFisica &&
          _vm.cadastrante.pessoa.pessoaFisica.cpf &&
          !_vm.isProcessoFisico
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _vm.cadastrante.pessoa.telefones &&
                  !_vm.isMaranhao &&
                  _vm.tipoProcesso !== "NAO_ONEROSO"
                    ? _c("app-display-multiple", {
                        class:
                          _vm.compararCadastrante &&
                          _vm.compararCadastrante.mudouPessoa &&
                          _vm.compararCadastrante.mudouPessoa.mudouTelefones
                            ? "text"
                            : "",
                        attrs: {
                          label: "Telefone(s):",
                          content: _vm.formatTelefone(
                            _vm.cadastrante.pessoa.telefones
                          )
                        }
                      })
                    : _vm._e(),
                  _vm.cadastrante.pessoa.email
                    ? _c("app-display", {
                        class:
                          _vm.compararCadastrante &&
                          _vm.compararCadastrante.mudouPessoa &&
                          _vm.compararCadastrante.mudouPessoa.mudouEmail
                            ? "text"
                            : "",
                        attrs: {
                          label: "E-mail:",
                          content: _vm.cadastrante.pessoa.email
                        }
                      })
                    : _vm._e(),
                  _vm.cadastrante.pessoa.pessoaFisica.dataNascimento
                    ? _c("app-display", {
                        class:
                          _vm.compararCadastrante &&
                          _vm.compararCadastrante.mudouPessoa &&
                          _vm.compararCadastrante.mudouPessoa
                            .mudouDataNascimento
                            ? "text"
                            : "",
                        attrs: {
                          label: "Data de nascimento:",
                          content:
                            _vm.cadastrante.pessoa.pessoaFisica.dataNascimento
                        }
                      })
                    : _vm._e(),
                  _vm.cadastrante.pessoa.pessoaFisica.estadoCivil
                    ? _c("app-display", {
                        class:
                          _vm.compararCadastrante &&
                          _vm.compararCadastrante.mudouPessoa &&
                          _vm.compararCadastrante.mudouPessoa.mudouEstadoCivil
                            ? "text"
                            : "",
                        attrs: {
                          label: "Estado civil:",
                          content:
                            _vm.cadastrante.pessoa.pessoaFisica.estadoCivil
                        }
                      })
                    : _vm._e(),
                  _vm.cadastrante.pessoa.pessoaFisica.orgaoExpedidor
                    ? _c("app-display", {
                        staticClass: "margin-top",
                        class:
                          _vm.compararCadastrante &&
                          _vm.compararCadastrante.mudouPessoa &&
                          _vm.compararCadastrante.mudouPessoa
                            .mudouOrgaoExpedidor
                            ? "text"
                            : "",
                        attrs: {
                          label: "Órgão expedidor:",
                          content:
                            _vm.cadastrante.pessoa.pessoaFisica.orgaoExpedidor
                              .nome
                        }
                      })
                    : _vm._e(),
                  this.cadastrante.tipo
                    ? _c("informacoes-especiais-cadastrante", {
                        attrs: {
                          cadastrante: _vm.cadastrante,
                          isOnerosoGroup: _vm.isOnerosoGroup,
                          mudouEspeciaisCadastrante: _vm.compararCadastrante
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      !_vm.isProcessoFisico && !_vm.isBahia
        ? _c(
            "el-row",
            { staticClass: "margin-top" },
            [
              _c(
                "el-col",
                [
                  _c(
                    "app-divider",
                    { attrs: { label: "Endereço do Cadastrante" } },
                    [
                      _c("informacoes-endereco", {
                        staticClass: "margin-top",
                        attrs: {
                          slot: "body",
                          endereco: _vm.enderecoCadastrante,
                          mudouEndereco:
                            _vm.compararCadastrante &&
                            _vm.compararCadastrante.mudouPessoa.mudouEndereco
                        },
                        slot: "body"
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e9e42214", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e9e42214","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/InformacoesCadastrante.vue
// module id = null
// module chunks = 